import React from 'react';
import { motion } from 'framer-motion';

const PageTemplate = ({ title, children, lastUpdated }) => {
  return (
    <section className="pt-32 pb-20 bg-navy min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto"
        >
          {/* Page Header */}
          <div className="mb-10">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {title}
            </h1>
            {lastUpdated && (
              <p className="text-gray-500 text-sm">
                Last updated: {lastUpdated}
              </p>
            )}
            <div className="w-20 h-1 bg-cyan rounded-full mt-4"></div>
          </div>

          {/* Page Content */}
          <div className="space-y-6 text-gray-300 leading-relaxed">
            {children}
          </div>

          {/* Back to Home Link */}
          <div className="mt-12 pt-8 border-t border-gray-800">
            <a href="/" className="text-cyan hover:text-cyan/80 transition inline-flex items-center gap-2">
              ← Back to Home
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PageTemplate;
